<h1>Όροι και προϋποθέσεις</h1>
<mat-dialog-content class="mat-typography">
    <div [innerHTML]="termsAndConditions" style="font-size: 11px;"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close>Εντάξει</button>
</mat-dialog-actions>